import { createApp } from "vue";
// this is the root component in which all other components are nested
import App from "./App.vue";
// this conntains the navigation
import router from "./router";
// used for state management in a vue app 
import store from "./store";

createApp(App).use(store).use(router).mount("#app");
